import type { ReactNode } from 'react'

import { Tabs as TabsPrimitive } from '@base-ui/react/tabs'
import { cn } from '@/lib/utils'

export const Tabs = ({ className, ...props }: TabsPrimitive.Root.Props): ReactNode => {
    return (
        <TabsPrimitive.Root
            data-slot='tabs'
            className={cn('flex flex-col gap-6', className)}
            {...props}
        />
    )
}

export const TabsList = ({ className, ...props }: TabsPrimitive.List.Props): ReactNode => {
    return (
        <TabsPrimitive.List
            data-slot='tabs-list'
            className={cn(
                'inline-flex w-fit items-center gap-1 rounded-full bg-white p-1 ring-1 ring-border',
                className
            )}
            {...props}
        />
    )
}

export const TabsTrigger = ({ className, ...props }: TabsPrimitive.Tab.Props): ReactNode => {
    return (
        <TabsPrimitive.Tab
            data-slot='tabs-trigger'
            className={cn(
                'inline-flex h-10 items-center justify-center gap-2 rounded-full px-5 text-sm font-semibold whitespace-nowrap text-muted-foreground transition-colors outline-none hover:text-ink focus-visible:ring-4 focus-visible:ring-ring/30 data-active:bg-primary data-active:text-primary-foreground data-active:shadow-md data-active:shadow-brand-700/20 [&_svg]:size-4 [&_svg]:shrink-0',
                className
            )}
            {...props}
        />
    )
}

export const TabsContent = ({ className, ...props }: TabsPrimitive.Panel.Props): ReactNode => {
    return (
        <TabsPrimitive.Panel
            data-slot='tabs-content'
            className={cn('outline-none', className)}
            {...props}
        />
    )
}
